// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/notifications.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/notifications.proto.
 */
export const file_cortado_v1_notifications: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_struct]);

/**
 * NotificationDigestSettings is an org's digest configuration.
 *
 * @generated from message cortado.v1.NotificationDigestSettings
 */
export type NotificationDigestSettings = Message<"cortado.v1.NotificationDigestSettings"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: cortado.v1.NotificationDigestFrequency frequency = 2;
   */
  frequency: NotificationDigestFrequency;

  /**
   * Hour of the day, 0-23, in the organization's timezone.
   *
   * @generated from field: int32 send_hour = 3;
   */
  sendHour: number;

  /**
   * Day of the week for weekly digests, 0 = Sunday through 6 = Saturday.
   *
   * @generated from field: int32 send_weekday = 4;
   */
  sendWeekday: number;

  /**
   * @generated from field: repeated cortado.v1.NotificationDigestSection sections = 5;
   */
  sections: NotificationDigestSection[];

  /**
   * A lead is stale after this many days without activity (1-90).
   *
   * @generated from field: int32 stale_lead_days = 6;
   */
  staleLeadDays: number;

  /**
   * Addresses outside the organization that also get the digest.
   *
   * @generated from field: repeated string additional_emails = 7;
   */
  additionalEmails: string[];

  /**
   * Members picked to get the digest.
   *
   * @generated from field: repeated string recipient_user_ids = 8;
   */
  recipientUserIds: string[];
};

/**
 * Describes the message cortado.v1.NotificationDigestSettings.
 * Use `create(NotificationDigestSettingsSchema)` to create a new message.
 */
export const NotificationDigestSettingsSchema: GenMessage<NotificationDigestSettings> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 0);

/**
 * NotificationDigestSend is one entry of the digest's delivery history.
 *
 * @generated from message cortado.v1.NotificationDigestSend
 */
export type NotificationDigestSend = Message<"cortado.v1.NotificationDigestSend"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: cortado.v1.NotificationDigestSendKind kind = 2;
   */
  kind: NotificationDigestSendKind;

  /**
   * @generated from field: cortado.v1.NotificationDigestSendStatus status = 3;
   */
  status: NotificationDigestSendStatus;

  /**
   * The period the digest covered, e.g. "daily:2026-10-29" or "weekly:2026-10-26".
   *
   * @generated from field: string period_key = 4;
   */
  periodKey: string;

  /**
   * @generated from field: int32 recipient_count = 5;
   */
  recipientCount: number;

  /**
   * @generated from field: int32 item_count = 6;
   */
  itemCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.NotificationDigestSend.
 * Use `create(NotificationDigestSendSchema)` to create a new message.
 */
export const NotificationDigestSendSchema: GenMessage<NotificationDigestSend> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 1);

/**
 * GetNotificationDigestRequest reads an organization's digest.
 *
 * @generated from message cortado.v1.GetNotificationDigestRequest
 */
export type GetNotificationDigestRequest = Message<"cortado.v1.GetNotificationDigestRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetNotificationDigestRequest.
 * Use `create(GetNotificationDigestRequestSchema)` to create a new message.
 */
export const GetNotificationDigestRequestSchema: GenMessage<GetNotificationDigestRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 2);

/**
 * GetNotificationDigestResponse returns the settings (defaults when never
 * saved), the timezone send times use, and the latest sends.
 *
 * @generated from message cortado.v1.GetNotificationDigestResponse
 */
export type GetNotificationDigestResponse = Message<"cortado.v1.GetNotificationDigestResponse"> & {
  /**
   * @generated from field: cortado.v1.NotificationDigestSettings settings = 1;
   */
  settings?: NotificationDigestSettings;

  /**
   * IANA timezone the send hour is read in.
   *
   * @generated from field: string timezone = 2;
   */
  timezone: string;

  /**
   * True when timezone is the fallback because the organization has none.
   *
   * @generated from field: bool timezone_is_fallback = 3;
   */
  timezoneIsFallback: boolean;

  /**
   * Last 10 sends, newest first.
   *
   * @generated from field: repeated cortado.v1.NotificationDigestSend recent_sends = 4;
   */
  recentSends: NotificationDigestSend[];
};

/**
 * Describes the message cortado.v1.GetNotificationDigestResponse.
 * Use `create(GetNotificationDigestResponseSchema)` to create a new message.
 */
export const GetNotificationDigestResponseSchema: GenMessage<GetNotificationDigestResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 3);

/**
 * UpdateNotificationDigestRequest saves an organization's digest settings.
 *
 * @generated from message cortado.v1.UpdateNotificationDigestRequest
 */
export type UpdateNotificationDigestRequest = Message<"cortado.v1.UpdateNotificationDigestRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.NotificationDigestSettings settings = 2;
   */
  settings?: NotificationDigestSettings;
};

/**
 * Describes the message cortado.v1.UpdateNotificationDigestRequest.
 * Use `create(UpdateNotificationDigestRequestSchema)` to create a new message.
 */
export const UpdateNotificationDigestRequestSchema: GenMessage<UpdateNotificationDigestRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 4);

/**
 * UpdateNotificationDigestResponse returns the saved digest.
 *
 * @generated from message cortado.v1.UpdateNotificationDigestResponse
 */
export type UpdateNotificationDigestResponse = Message<"cortado.v1.UpdateNotificationDigestResponse"> & {
  /**
   * @generated from field: cortado.v1.NotificationDigestSettings settings = 1;
   */
  settings?: NotificationDigestSettings;

  /**
   * @generated from field: string timezone = 2;
   */
  timezone: string;

  /**
   * @generated from field: bool timezone_is_fallback = 3;
   */
  timezoneIsFallback: boolean;

  /**
   * @generated from field: repeated cortado.v1.NotificationDigestSend recent_sends = 4;
   */
  recentSends: NotificationDigestSend[];
};

/**
 * Describes the message cortado.v1.UpdateNotificationDigestResponse.
 * Use `create(UpdateNotificationDigestResponseSchema)` to create a new message.
 */
export const UpdateNotificationDigestResponseSchema: GenMessage<UpdateNotificationDigestResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 5);

/**
 * SendTestNotificationDigestRequest sends the digest, built from the saved
 * settings, to the calling user only.
 *
 * @generated from message cortado.v1.SendTestNotificationDigestRequest
 */
export type SendTestNotificationDigestRequest = Message<"cortado.v1.SendTestNotificationDigestRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.SendTestNotificationDigestRequest.
 * Use `create(SendTestNotificationDigestRequestSchema)` to create a new message.
 */
export const SendTestNotificationDigestRequestSchema: GenMessage<SendTestNotificationDigestRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 6);

/**
 * SendTestNotificationDigestResponse says where the test went.
 *
 * @generated from message cortado.v1.SendTestNotificationDigestResponse
 */
export type SendTestNotificationDigestResponse = Message<"cortado.v1.SendTestNotificationDigestResponse"> & {
  /**
   * @generated from field: string recipient_email = 1;
   */
  recipientEmail: string;

  /**
   * @generated from field: int32 item_count = 2;
   */
  itemCount: number;

  /**
   * @generated from field: string send_id = 3;
   */
  sendId: string;
};

/**
 * Describes the message cortado.v1.SendTestNotificationDigestResponse.
 * Use `create(SendTestNotificationDigestResponseSchema)` to create a new message.
 */
export const SendTestNotificationDigestResponseSchema: GenMessage<SendTestNotificationDigestResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 7);

/**
 * InAppNotification represents an in-app notification for a user
 *
 * @generated from message cortado.v1.InAppNotification
 */
export type InAppNotification = Message<"cortado.v1.InAppNotification"> & {
  /**
   * Unique identifier
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization this notification belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * User who receives this notification
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * Type of notification (e.g., "new_inquiry", "payment_received", "task_assigned")
   *
   * @generated from field: string notification_type = 4;
   */
  notificationType: string;

  /**
   * Short title for the notification
   *
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * Notification body/description
   *
   * @generated from field: string body = 6;
   */
  body: string;

  /**
   * Optional URL to navigate to when clicked
   *
   * @generated from field: optional string action_url = 7;
   */
  actionUrl?: string;

  /**
   * Optional metadata for additional context
   *
   * @generated from field: google.protobuf.Struct metadata = 8;
   */
  metadata?: JsonObject;

  /**
   * When the notification was read (null if unread)
   *
   * @generated from field: optional google.protobuf.Timestamp read_at = 9;
   */
  readAt?: Timestamp;

  /**
   * When the notification was archived (null if not archived)
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 10;
   */
  archivedAt?: Timestamp;

  /**
   * When the notification was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * The user who triggered this notification (optional)
   *
   * @generated from field: optional string actor_user_id = 12;
   */
  actorUserId?: string;
};

/**
 * Describes the message cortado.v1.InAppNotification.
 * Use `create(InAppNotificationSchema)` to create a new message.
 */
export const InAppNotificationSchema: GenMessage<InAppNotification> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 8);

/**
 * ListInAppNotificationsRequest retrieves in-app notifications for the current user
 *
 * @generated from message cortado.v1.ListInAppNotificationsRequest
 */
export type ListInAppNotificationsRequest = Message<"cortado.v1.ListInAppNotificationsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Filter: only unread notifications
   *
   * @generated from field: optional bool unread_only = 2;
   */
  unreadOnly?: boolean;

  /**
   * Pagination
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message cortado.v1.ListInAppNotificationsRequest.
 * Use `create(ListInAppNotificationsRequestSchema)` to create a new message.
 */
export const ListInAppNotificationsRequestSchema: GenMessage<ListInAppNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 9);

/**
 * ListInAppNotificationsResponse contains the list of in-app notifications
 *
 * @generated from message cortado.v1.ListInAppNotificationsResponse
 */
export type ListInAppNotificationsResponse = Message<"cortado.v1.ListInAppNotificationsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.InAppNotification notifications = 1;
   */
  notifications: InAppNotification[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListInAppNotificationsResponse.
 * Use `create(ListInAppNotificationsResponseSchema)` to create a new message.
 */
export const ListInAppNotificationsResponseSchema: GenMessage<ListInAppNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 10);

/**
 * MarkNotificationsReadRequest marks one or more notifications as read
 *
 * @generated from message cortado.v1.MarkNotificationsReadRequest
 */
export type MarkNotificationsReadRequest = Message<"cortado.v1.MarkNotificationsReadRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Notification IDs to mark as read. If empty, marks all as read.
   *
   * @generated from field: repeated string notification_ids = 2;
   */
  notificationIds: string[];
};

/**
 * Describes the message cortado.v1.MarkNotificationsReadRequest.
 * Use `create(MarkNotificationsReadRequestSchema)` to create a new message.
 */
export const MarkNotificationsReadRequestSchema: GenMessage<MarkNotificationsReadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 11);

/**
 * MarkNotificationsReadResponse confirms the operation
 *
 * @generated from message cortado.v1.MarkNotificationsReadResponse
 */
export type MarkNotificationsReadResponse = Message<"cortado.v1.MarkNotificationsReadResponse"> & {
  /**
   * @generated from field: int32 updated_count = 1;
   */
  updatedCount: number;
};

/**
 * Describes the message cortado.v1.MarkNotificationsReadResponse.
 * Use `create(MarkNotificationsReadResponseSchema)` to create a new message.
 */
export const MarkNotificationsReadResponseSchema: GenMessage<MarkNotificationsReadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 12);

/**
 * ArchiveNotificationsRequest archives one or more notifications
 *
 * @generated from message cortado.v1.ArchiveNotificationsRequest
 */
export type ArchiveNotificationsRequest = Message<"cortado.v1.ArchiveNotificationsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Notification IDs to archive. If empty, archives all.
   *
   * @generated from field: repeated string notification_ids = 2;
   */
  notificationIds: string[];
};

/**
 * Describes the message cortado.v1.ArchiveNotificationsRequest.
 * Use `create(ArchiveNotificationsRequestSchema)` to create a new message.
 */
export const ArchiveNotificationsRequestSchema: GenMessage<ArchiveNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 13);

/**
 * ArchiveNotificationsResponse confirms the operation
 *
 * @generated from message cortado.v1.ArchiveNotificationsResponse
 */
export type ArchiveNotificationsResponse = Message<"cortado.v1.ArchiveNotificationsResponse"> & {
  /**
   * @generated from field: int32 updated_count = 1;
   */
  updatedCount: number;
};

/**
 * Describes the message cortado.v1.ArchiveNotificationsResponse.
 * Use `create(ArchiveNotificationsResponseSchema)` to create a new message.
 */
export const ArchiveNotificationsResponseSchema: GenMessage<ArchiveNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 14);

/**
 * GetUnreadNotificationCountRequest gets the count of unread notifications
 *
 * @generated from message cortado.v1.GetUnreadNotificationCountRequest
 */
export type GetUnreadNotificationCountRequest = Message<"cortado.v1.GetUnreadNotificationCountRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetUnreadNotificationCountRequest.
 * Use `create(GetUnreadNotificationCountRequestSchema)` to create a new message.
 */
export const GetUnreadNotificationCountRequestSchema: GenMessage<GetUnreadNotificationCountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 15);

/**
 * GetUnreadNotificationCountResponse contains the unread count
 *
 * @generated from message cortado.v1.GetUnreadNotificationCountResponse
 */
export type GetUnreadNotificationCountResponse = Message<"cortado.v1.GetUnreadNotificationCountResponse"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message cortado.v1.GetUnreadNotificationCountResponse.
 * Use `create(GetUnreadNotificationCountResponseSchema)` to create a new message.
 */
export const GetUnreadNotificationCountResponseSchema: GenMessage<GetUnreadNotificationCountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 16);

/**
 * UserNotificationSetting is one notification type the caller can turn on or
 * off for themselves, with their current choice.
 *
 * @generated from message cortado.v1.UserNotificationSetting
 */
export type UserNotificationSetting = Message<"cortado.v1.UserNotificationSetting"> & {
  /**
   * In-app notification type, e.g. "email_reply_received"
   *
   * @generated from field: string notification_type = 1;
   */
  notificationType: string;

  /**
   * Short name for the settings screen
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * One sentence on when it is raised
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: cortado.v1.UserNotificationDelivery delivery = 4;
   */
  delivery: UserNotificationDelivery;
};

/**
 * Describes the message cortado.v1.UserNotificationSetting.
 * Use `create(UserNotificationSettingSchema)` to create a new message.
 */
export const UserNotificationSettingSchema: GenMessage<UserNotificationSetting> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 17);

/**
 * ListMyNotificationSettingsRequest lists the caller's own settings.
 *
 * @generated from message cortado.v1.ListMyNotificationSettingsRequest
 */
export type ListMyNotificationSettingsRequest = Message<"cortado.v1.ListMyNotificationSettingsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.ListMyNotificationSettingsRequest.
 * Use `create(ListMyNotificationSettingsRequestSchema)` to create a new message.
 */
export const ListMyNotificationSettingsRequestSchema: GenMessage<ListMyNotificationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 18);

/**
 * @generated from message cortado.v1.ListMyNotificationSettingsResponse
 */
export type ListMyNotificationSettingsResponse = Message<"cortado.v1.ListMyNotificationSettingsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.UserNotificationSetting settings = 1;
   */
  settings: UserNotificationSetting[];
};

/**
 * Describes the message cortado.v1.ListMyNotificationSettingsResponse.
 * Use `create(ListMyNotificationSettingsResponseSchema)` to create a new message.
 */
export const ListMyNotificationSettingsResponseSchema: GenMessage<ListMyNotificationSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 19);

/**
 * UpdateMyNotificationSettingRequest sets the caller's choice for one type.
 *
 * @generated from message cortado.v1.UpdateMyNotificationSettingRequest
 */
export type UpdateMyNotificationSettingRequest = Message<"cortado.v1.UpdateMyNotificationSettingRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string notification_type = 2;
   */
  notificationType: string;

  /**
   * @generated from field: cortado.v1.UserNotificationDelivery delivery = 3;
   */
  delivery: UserNotificationDelivery;
};

/**
 * Describes the message cortado.v1.UpdateMyNotificationSettingRequest.
 * Use `create(UpdateMyNotificationSettingRequestSchema)` to create a new message.
 */
export const UpdateMyNotificationSettingRequestSchema: GenMessage<UpdateMyNotificationSettingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 20);

/**
 * @generated from message cortado.v1.UpdateMyNotificationSettingResponse
 */
export type UpdateMyNotificationSettingResponse = Message<"cortado.v1.UpdateMyNotificationSettingResponse"> & {
  /**
   * @generated from field: cortado.v1.UserNotificationSetting setting = 1;
   */
  setting?: UserNotificationSetting;
};

/**
 * Describes the message cortado.v1.UpdateMyNotificationSettingResponse.
 * Use `create(UpdateMyNotificationSettingResponseSchema)` to create a new message.
 */
export const UpdateMyNotificationSettingResponseSchema: GenMessage<UpdateMyNotificationSettingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_notifications, 21);

/**
 * NotificationDigestFrequency is how often the org digest goes out.
 *
 * @generated from enum cortado.v1.NotificationDigestFrequency
 */
export enum NotificationDigestFrequency {
  /**
   * @generated from enum value: NOTIFICATION_DIGEST_FREQUENCY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_DIGEST_FREQUENCY_DAILY = 1;
   */
  DAILY = 1,

  /**
   * @generated from enum value: NOTIFICATION_DIGEST_FREQUENCY_WEEKLY = 2;
   */
  WEEKLY = 2,
}

/**
 * Describes the enum cortado.v1.NotificationDigestFrequency.
 */
export const NotificationDigestFrequencySchema: GenEnum<NotificationDigestFrequency> = /*@__PURE__*/
  enumDesc(file_cortado_v1_notifications, 0);

/**
 * NotificationDigestSection is one block the digest can include. The email
 * shows them in this order.
 *
 * @generated from enum cortado.v1.NotificationDigestSection
 */
export enum NotificationDigestSection {
  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Upcoming events in the next 3 days (daily) or 7 days (weekly).
   *
   * @generated from enum value: NOTIFICATION_DIGEST_SECTION_UPCOMING_EVENTS = 1;
   */
  UPCOMING_EVENTS = 1,

  /**
   * Open tasks past their due date.
   *
   * @generated from enum value: NOTIFICATION_DIGEST_SECTION_OVERDUE_TASKS = 2;
   */
  OVERDUE_TASKS = 2,

  /**
   * Open leads with no activity for stale_lead_days.
   *
   * @generated from enum value: NOTIFICATION_DIGEST_SECTION_STALE_LEADS = 3;
   */
  STALE_LEADS = 3,

  /**
   * Overdue payments and payments due within the lookahead.
   *
   * @generated from enum value: NOTIFICATION_DIGEST_SECTION_PAYMENTS_DUE = 4;
   */
  PAYMENTS_DUE = 4,
}

/**
 * Describes the enum cortado.v1.NotificationDigestSection.
 */
export const NotificationDigestSectionSchema: GenEnum<NotificationDigestSection> = /*@__PURE__*/
  enumDesc(file_cortado_v1_notifications, 1);

/**
 * NotificationDigestSendKind says whether a send was scheduled or a test.
 *
 * @generated from enum cortado.v1.NotificationDigestSendKind
 */
export enum NotificationDigestSendKind {
  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_KIND_SCHEDULED = 1;
   */
  SCHEDULED = 1,

  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_KIND_TEST = 2;
   */
  TEST = 2,
}

/**
 * Describes the enum cortado.v1.NotificationDigestSendKind.
 */
export const NotificationDigestSendKindSchema: GenEnum<NotificationDigestSendKind> = /*@__PURE__*/
  enumDesc(file_cortado_v1_notifications, 2);

/**
 * NotificationDigestSendStatus is how a send ended.
 *
 * @generated from enum cortado.v1.NotificationDigestSendStatus
 */
export enum NotificationDigestSendStatus {
  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_STATUS_SENT = 2;
   */
  SENT = 2,

  /**
   * Nothing to report, so nothing was sent.
   *
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_STATUS_SKIPPED_EMPTY = 3;
   */
  SKIPPED_EMPTY = 3,

  /**
   * No recipient was left after membership and opt-outs.
   *
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_STATUS_SKIPPED_NO_RECIPIENTS = 4;
   */
  SKIPPED_NO_RECIPIENTS = 4,

  /**
   * @generated from enum value: NOTIFICATION_DIGEST_SEND_STATUS_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * Describes the enum cortado.v1.NotificationDigestSendStatus.
 */
export const NotificationDigestSendStatusSchema: GenEnum<NotificationDigestSendStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_notifications, 3);

/**
 * UserNotificationDelivery is how one user receives one notification type.
 *
 * @generated from enum cortado.v1.UserNotificationDelivery
 */
export enum UserNotificationDelivery {
  /**
   * @generated from enum value: USER_NOTIFICATION_DELIVERY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * In the bell as soon as it happens (the default).
   *
   * @generated from enum value: USER_NOTIFICATION_DELIVERY_INSTANT = 1;
   */
  INSTANT = 1,

  /**
   * Not at all.
   *
   * @generated from enum value: USER_NOTIFICATION_DELIVERY_OFF = 2;
   */
  OFF = 2,
}

/**
 * Describes the enum cortado.v1.UserNotificationDelivery.
 */
export const UserNotificationDeliverySchema: GenEnum<UserNotificationDelivery> = /*@__PURE__*/
  enumDesc(file_cortado_v1_notifications, 4);

